import palette from 'constants/palette'
import { StyleState } from './types'

export const initialState: StyleState = {
  settings: {
    placement: 'bottom',
    backgroundColor: palette.grey90,
    defaultLabelColor: palette.grey30,
    selectedLabelColor: palette.spearmint,
  },
  isLoading: false,
  hasChanges: false,
}

export default initialState
